/**
 * @generated SignedSource<<d74116ddf84c22c868c27826499d1987>>
 * @relayHash 1b34c24939127448f5c00dae3686d441
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4c221363cc883efefab5cfa0e3ab169a67cfbd5e0421720c08604343009f0248

import type { ConcreteRequest } from 'relay-runtime';
export type useAllowNestedCommentsDetailsPanelContentCreatedDateQuery$variables = {
  contentId: string;
  status: string;
};
export type useAllowNestedCommentsDetailsPanelContentCreatedDateQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly metadata: {
        readonly createdDate: string | null;
      };
    } | null> | null;
  } | null;
};
export type useAllowNestedCommentsDetailsPanelContentCreatedDateQuery = {
  response: useAllowNestedCommentsDetailsPanelContentCreatedDateQuery$data;
  variables: useAllowNestedCommentsDetailsPanelContentCreatedDateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "items": [
          {
            "kind": "Variable",
            "name": "status.0",
            "variableName": "status"
          }
        ],
        "kind": "ListValue",
        "name": "status"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "createdDate"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAllowNestedCommentsDetailsPanelContentCreatedDateQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAllowNestedCommentsDetailsPanelContentCreatedDateQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1b34c24939127448f5c00dae3686d441",
    "id": "4c221363cc883efefab5cfa0e3ab169a67cfbd5e0421720c08604343009f0248",
    "metadata": {},
    "name": "useAllowNestedCommentsDetailsPanelContentCreatedDateQuery",
    "operationKind": "query",
    "text": "query useAllowNestedCommentsDetailsPanelContentCreatedDateQuery($contentId:ID!,$status:String!){content(id:$contentId,status:[$status]){nodes{id,metadata{createdDate}}}}"
  }
};
})();

(node as any).hash = "654d747af6c04558b92d70397d0023f0";

export default node;
